<script>import { ICON_STROKE_MAP } from "./";
export let size = 24;
</script>
<svg width={size} height={size} stroke-width={ICON_STROKE_MAP[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}><path d="M9 18L15 12L9 6" stroke="currentColor"/></svg>